import { Routes } from '@angular/router';
import { titleResolver } from '@se/platform';
import { EmptyComponent } from '../empty/empty.component';

export const routes: Routes = [
    {
        path: 'new',
        children: [
            {
                path: 'vnext',
                children: [
                    {
                        path: 'cardio-visit',
                        title: titleResolver,
                        data: { mainStateCode: 'REPORTLISTVS' },
                        loadChildren: () => import('@se/modules.cardiology.visit').then((m) => m.CardiologyVisitModule),
                    },
                    {
                        path: 'specialty-reporting',
                        title: titleResolver,
                        data: { mainStateCode: 'REPORTLISTSPECIALTY' },
                        loadChildren: () =>
                            import('@se/modules.specialty.reporting').then((m) => m.SpecialtyReportingModule),
                    },
                    {
                        path: 'cp',
                        loadChildren: () => import('@se/modules.custompages').then((m) => m.SeCustompagesModule),
                    },
                    {
                        path: 'ecg',
                        title: titleResolver,
                        data: { mainStateCode: 'REPORTLISTECG' },
                        loadChildren: () =>
                            import('@se/modules.cardiology.ecgreporting').then((m) => m.CardiologyEcgReportingModule),
                    },
                    {
                        path: 'mps',
                        loadChildren: () => import('@se/modules.mps').then((m) => m.MpsModule),
                    },
                    {
                        path: 'collaboration',
                        loadChildren: () => import('@se/modules.collaboration').then((m) => m.CollaborationModule),
                    },
                    {
                        path: 'tool',
                        loadChildren: () => import('@se/modules.toolupload').then((m) => m.TooluploadModule),
                    },
                    {
                        path: 'telemonitoring',
                        loadChildren: () => import('@se/modules.telemonitoring').then((m) => m.TelemonitoringModule),
                    },
                    {
                        path: 'third-part-waiting',
                        data: {
                            message: 'ThirdPartsWaitingForOps',
                        },
                        component: EmptyComponent,
                    },
                    {
                        path: 'nre',
                        loadChildren: () => import('@se/modules.nre').then((m) => m.NreModule),
                    },
                    {
                        path: 'teleconsultation',
                        loadChildren: () =>
                            import('@se/modules.teleconsultation').then((m) => m.TeleconsultationModule),
                    },
                    {
                        path: 'administrative',
                        loadChildren: () => import('@se/modules.administrative.pages').then((m) => m.ApModule),
                    },
                    {
                        path: 'default-text',
                        title: titleResolver,
                        data: { mainStateCode: 'DEFAULTTEXTMGNT' },
                        loadChildren: () =>
                            import('@se/modules.default.text.mgnt').then((m) => m.DefaultTextMgntModule),
                    },
                ],
            },
        ],
    },
    {
        path: '**',
        title: titleResolver,
        component: EmptyComponent,
        pathMatch: 'full',
    },
];
